import React, { useRef, useEffect } from "react";

// One-shot radial burst of connected light nodes — "connessione avvenuta".
export default function ConnectionBurst({ className = "" }) {
  const canvasRef = useRef(null);

  useEffect(() => {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    const w = (canvas.width = canvas.offsetWidth);
    const h = (canvas.height = canvas.offsetHeight);
    const cx = w / 2;
    const cy = h / 2.4;
    const colors = ["#f5c542", "#ff7a1a", "#e60000"];
    const N = 26;
    const nodes = Array.from({ length: N }, (_, i) => {
      const ang = (i / N) * Math.PI * 2 + Math.random() * 0.3;
      const speed = 2.6 + Math.random() * 3.2;
      return { ang, speed, c: colors[i % colors.length], r: 1.5 + Math.random() * 1.5 };
    });

    let start = null;
    let raf;
    const DURATION = 1300;

    const frame = (t) => {
      if (start === null) start = t;
      const p = Math.min(1, (t - start) / DURATION);
      const ease = 1 - Math.pow(1 - p, 3);
      const alpha = 1 - p;
      ctx.clearRect(0, 0, w, h);

      const pos = nodes.map((n) => {
        const dist = ease * n.speed * 60;
        return { x: cx + Math.cos(n.ang) * dist, y: cy + Math.sin(n.ang) * dist, c: n.c, r: n.r };
      });

      // lines from center + between neighbors
      ctx.lineWidth = 0.8;
      pos.forEach((a, i) => {
        ctx.beginPath();
        ctx.moveTo(cx, cy);
        ctx.lineTo(a.x, a.y);
        ctx.strokeStyle = a.c;
        ctx.globalAlpha = alpha * 0.35;
        ctx.stroke();
        const b = pos[(i + 1) % pos.length];
        ctx.beginPath();
        ctx.moveTo(a.x, a.y);
        ctx.lineTo(b.x, b.y);
        ctx.globalAlpha = alpha * 0.2;
        ctx.stroke();
      });

      pos.forEach((a) => {
        ctx.beginPath();
        ctx.arc(a.x, a.y, a.r, 0, Math.PI * 2);
        ctx.fillStyle = a.c;
        ctx.globalAlpha = alpha;
        ctx.shadowColor = a.c;
        ctx.shadowBlur = 10;
        ctx.fill();
      });
      ctx.shadowBlur = 0;
      ctx.globalAlpha = 1;

      if (p < 1) raf = requestAnimationFrame(frame);
    };
    if (!reduce) raf = requestAnimationFrame(frame);

    return () => cancelAnimationFrame(raf);
  }, []);

  return <canvas ref={canvasRef} className={`pointer-events-none absolute inset-0 h-full w-full ${className}`} aria-hidden="true" />;
}
